export default __webpack_public_path__ + "static/media/OrderTagOne.e51fc2b9.png";